import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useSocietyProviderService from '../../../app/services/hooks/useSocietyProviderService';

interface Props {
    societyProviderId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ProviderSwitchChange = ({ societyProviderId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeSocietyProvider, fetchingActiveSocietyProvider } = useSocietyProviderService();

    const active = (value: boolean) => {
        setChecked(value);

        activeSocietyProvider(societyProviderId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={societyProviderId} callback={active} />;
};

export default ProviderSwitchChange;
